// extracted by mini-css-extract-plugin
export default {"box":"Sspecifications_box__hdE37","Sspecifications":"Sspecifications_Sspecifications__UDwF+"};